<template>
  <div class="super_container">
    <!-- Home -->

    <div class="home">
      <div class="home_background" style="background-image: url(images/home.jpg)"></div>
      <div class="home_content">
        <div class="home_content_inner">
          <div class="home_text_large">zwiedzaj</div>
          <div class="home_text_small">Razem z nami</div>
        </div>

        <div v-if="loggedUser" class="user-notifications">
          <div>
            <router-link :to="{ name: 'reservations' }">
              Nowe rezerwacje: {{ loggedUser.unread_reservations_count }}
            </router-link>
          </div>
          <div>
            <router-link :to="{ name: 'contacts' }">
              Nowe wiadomości: {{ loggedUser.unread_contacts_count }}
            </router-link>
          </div>
          <div>
            <router-link :to="{ name: 'subscriptions' }">
              Nowe subskrypcje: {{ loggedUser.unread_subscriptions_count }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Find Form -->

    <TripContact />

    <!-- Top Destinations -->

    <div class="top">
      <div v-show="favouriteTrips.length" class="container">
        <div class="row">
          <div class="col">
            <div class="section_title text-center">
              <h2>Poznaj naszych ulubieńców</h2>
              <div>wybierz się w przygodę marzeń</div>
            </div>
          </div>
        </div>
        <div class="row top_content">
          <div v-for="trip in favouriteTrips" :key="trip.id" class="col-lg-3 col-md-6 top_col">
            <!-- Top Destination Item -->
            <div class="top_item">
              <router-link
                :to="{
                  name: 'trip',
                  params: { id: trip.id },
                }"
              >
                <div class="top_item_image">
                  <MImage
                    :default-img="trip.photo"
                    :trip="trip"
                    alt="zdjęcie wycieczki"
                    :srcset="trip.thumbnail_photo + ', ' + trip.small_photo + ', ' + trip.photo"
                    sizes="(max-width: 425px), (max-width: 720px)"
                  />
                </div>
                <div class="top_item_content">
                  <div v-show="trip.price" class="top_item_price">{{ trip.price }} zł</div>
                  <div class="top_item_text">{{ trip.title }}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popular -->

    <div v-show="trips.length" class="popular top">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title text-center">
              <h2>Nasze wycieczki 2019</h2>
              <div>zwiedzaj świat z biurem podróży Marena</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div
              class="popular_content d-flex flex-md-row flex-column flex-wrap align-items-md-center align-items-start justify-content-md-between justify-content-start"
            >
              <!-- Popular Item -->
              <div v-for="trip in trips" :key="trip.id" class="popular_item">
                <router-link
                  :to="{
                    name: 'trip',
                    params: { id: trip.id },
                  }"
                >
                  <MImage
                    :default-img="trip.thumbnail_photo"
                    :trip="trip"
                    alt="zdjęcie wycieczki"
                  />
                  <div class="popular_item_content">
                    <div v-show="trip.price" class="popular_item_price">{{ trip.price }}zł</div>
                    <div class="popular_item_title">
                      {{ trip.title }}
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="m-loading-status">
      <i v-show="loading" class="fa fa-spinner fa-spin" />
      <h2 v-show="!loading && !trips.length && !favouriteTrips.length">Brak danych</h2>
    </div>

    <!-- Video -->

    <!-- <div class="video_section d-flex flex-column align-items-center justify-content-center">
		<div class="video_background parallax-window" data-parallax="scroll" style="background-image:url(images/video.jpg)" data-speed="0.8"></div>
		<div class="video_content">
			<div class="video_title">Zwiedzanie wiednia 2018</div>
			<div class="video_subtitle">
				Biuro podróży Marena
			</div>
			<div class="video_play">
				<a  class="video" href="https://www.youtube.com/watch?v=BzMLA8YIgG0">
					<svg version="1.1" id="Layer_1" class="play_button" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						 width="140px" height="140px" viewBox="0 0 140 140" enable-background="new 0 0 140 140" xml:space="preserve">
						<g id="Layer_2">
							<circle class="play_circle" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" cx="70.333" cy="69.58" r="68.542"/>
							<polygon class="play_triangle" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-miterlimit="10" points="61.583,56 61.583,84.417 84.75,70 	"/>
						</g>
					</svg>
				</a>
			</div>
		</div>
	</div> -->
  </div>
</template>

<script>
import cli from '@/http.js'
import TripContact from '@/components/TripContact.vue'
import MImage from '@/components/MImage.vue'
import { mapState, mapActions } from 'vuex'
import storage from 'store'

export default {
  name: 'Home',
  components: {
    TripContact,
    MImage,
  },
  data() {
    return {
      favouriteTrips: [],
      trips: [],
      loading: true,
    }
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  methods: {
    ...mapActions(['refreshUser']),
    async fetchFavouriteTrips() {
      const resp = await cli.get('/trips/?is_favourite=true')
      this.favouriteTrips = resp.data.results
    },
    async fetchTrips() {
      const resp = await cli.get('/trips/')
      this.trips = resp.data.results
    },
  },
  async created() {
    try {
      const initialPromises = [this.fetchFavouriteTrips(), this.fetchTrips()]
      await Promise.all(initialPromises)
    } catch (err) {
      this.$notify({
        title: 'Błąd',
        text: err.message,
        type: 'error',
      })
    }
    this.loading = false
  },
}
</script>

<style scoped>
.top_item_image {
  height: 400px;
  overflow: hidden;
}
.top_item_image img {
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-out;
  object-fit: cover;
  opacity: 0.95;
}
.top_item_image:hover img {
  opacity: 1;
  height: 105%;
}
.top_item_content {
  width: 100%;
  background: #e0700ff0;
  padding: 10px;
  left: 0;
  text-align: center;
}

.popular_item {
  height: 200px;
  margin: 3px;
  overflow: hidden;
}
.popular_item_content {
  min-height: 74px;
  vertical-align: middle;
  text-align: center;
}
.popular_item_title {
  position: absolute;
  width: calc(100% - 7px);
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}
.popular_item a {
  height: 100%;
}
.popular_item img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: all 0.3s ease-out;
  opacity: 0.95;
}
.popular_item:hover img {
  height: 105%;
  opacity: 1;
}
.popular_item_content {
  width: 100%;
  background: #e0700ff0;
  left: 0;
  padding: 7px;
  text-align: center;
}

.justify-content-md-between {
  justify-content: start !important;
}

.user-notifications {
  margin: auto;
  margin-top: 20px;
  font-size: 1.2rem;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.4);
}
</style>
